import type { OrdenDoc } from '@/datos/tipos';
import { diaIso, fechaDeIso } from '@/lib/tiempo';
import { Insignia, type TonoInsignia } from '@/ui/basicos';

export type Repuesto = OrdenDoc['repuestos'][number];
export type EstadoRepuesto = Repuesto['estado'];

export const estadosRepuesto: { id: EstadoRepuesto; nombre: string; tono: TonoInsignia }[] = [
  { id: 'pendiente', nombre: 'Por pedir', tono: 'neutro' },
  { id: 'pedido', nombre: 'Pedido', tono: 'primario' },
  { id: 'recibido', nombre: 'Disponible', tono: 'exito' },
];

/** Not received and its expected date already passed (Santiago calendar). */
export function repuestoAtrasado(r: Repuesto, ahora = Date.now()): boolean {
  return r.estado !== 'recibido' && !!r.llegada && r.llegada < diaIso(ahora);
}

export function InsigniaRepuesto({ r, ahora }: { r: Repuesto; ahora?: number }) {
  const e = estadosRepuesto.find((x) => x.id === r.estado) ?? estadosRepuesto[0];
  if (repuestoAtrasado(r, ahora))
    return (
      <Insignia tono="alerta">Atrasado{r.llegada ? ` · ${fechaDeIso(r.llegada)}` : ''}</Insignia>
    );
  return (
    <Insignia tono={e?.tono ?? 'neutro'}>
      {e?.nombre}
      {r.estado === 'pedido' && r.llegada ? ` · llega ${fechaDeIso(r.llegada)}` : ''}
    </Insignia>
  );
}
